import { loadBuilderData } from "./components/results-load/builder-load";
import { renderFilters } from "./components/filters/filters";
import { setSlider } from "./components/filters/sliderRange";
import { loadInfoData } from "./components/results-load/results-ui";
// Mapping fields to DOM elements
export let fieldsBuilder = {};
function initializeFieldsBuilder() {
    fieldsBuilder = {
        'department_list': document.getElementById('department_value_builder'),
        'cities': document.getElementById('cities_value_builder'),
        'zone': document.getElementById('zone_value_builder'),
        'sector': document.getElementById('sector_value_builder'),
    };
}
document.addEventListener('DOMContentLoaded', () => {
    initializeFieldsBuilder();
});
/**
 * Sets the builder data to the page.
 * @param data The API response data.
 */
export function setDataBuilder(data) {
    // Hide 'load more' button if there are fewer than or equal to 12 results
    toggleLoadMoreButton(data.NumItems);
    // Load information into the builder fields
    loadInfoData(data, fieldsBuilder);
    // Initialize the price slider for builder page
    setSlider('precio_builder');
    // Send data to Vue.js
    renderFilters(true);
}
/**
 * Toggles the visibility of the 'load more' button based on the total number of items.
 * @param numberTotal The total number of items.
 */
function toggleLoadMoreButton(numberTotal) {
    const moreResultsElement = document.getElementById('more-results-builder');
    if (numberTotal <= 12 && moreResultsElement) {
        moreResultsElement.classList.add('d-none');
    }
}
/**
 * Fetches and loads the builder data APIs.
 * @param filter The filter string to be applied in the API request.
 * @returns The API response data.
 */
export async function loadApisBuilder(filter) {
    // Fetch the builder data
    const builderData = await fetchBuilderData(filter);
    fillBuilderHtml(builderData.Items);
    // Fetch additional filter data
    return await fetchAdditionalFilterData(filter);
}
/**
 * Fetches the builder data based on the given filter.
 * @param filter The filter string to be applied.
 * @returns The builder API response.
 */
async function fetchBuilderData(filter) {
    const response = await fetch(`/results-api${filter}&result-type=1`);
    return await response.json();
}
/**
 * Fetches the additional filter data.
 * @param filter The filter string to be applied.
 * @returns The filter data response.
 */
async function fetchAdditionalFilterData(filter) {
    const response = await fetch(`/results-filters${filter}`);
    return await response.json();
}
/**
 * Fills the builder data into the HTML.
 * @param buildersData The list of builder data to be displayed.
 */
export function fillBuilderHtml(buildersData) {
    let builderContent = "";
    buildersData.forEach((builder) => {
        const imgAlt = `Logo ${builder.field_project_name} de la constructora ${builder.field_builder_name}`;
        builderContent += `
      <a class="project-brand__card" href="${builder.field_project_url}">
        <img width="80" height="80" src="${builder.field_project_logo}" alt="${imgAlt}" class="project-brand__image"/>
        <p class="project-brand__name"> ${builder.field_project_name} </p>
      </a>
    `;
    });
    const resultsElement = document.getElementById('results-builder-project');
    if (resultsElement) {
        resultsElement.innerHTML = builderContent;
    }
}
// Initialize page data and functionality
if (window.location.pathname.includes('/constructora-') || window.location.pathname.includes('/que-estas-buscando')) {
    loadBuilderData();
}
